import { addError } from '../../../Common/ErrorHandling/store'
import { AppDispatch } from '../../../store'

export const handelFormSuccess = (
  translatedTitle: string,
  dispatch: AppDispatch,
) => {
  dispatch(
    addError({
      type: 'success',
      title: translatedTitle,
      icon: 'info-circle',
      duration: 'short',
    }),
  )
}
